import {
    LOGIC_OPERATOR_EQUALS,
    LOGIC_OPERATOR_EQUALS_ANY,
    LOGIC_OPERATOR_NOT_EQUALS,
    LOGIC_OPERATOR_NOT_EQUALS_ANY,
    LOGIC_OPERATOR_GREATER_THAN,
    LOGIC_OPERATOR_LESS_THAN,
    LOGIC_OPERATOR_CONTAINS,
    LOGIC_OPERATOR_NOT_CONTAINS,
    LOGIC_OPERATOR_REGEX,
} from 'common/entities/formLogicRule/constants';

export const REGEX_LABEL = 'matches RegExp';
export const GREATER_THAN_LABEL = 'is greater than';
export const LESS_THAN_LABEL = 'is less than';
export const EQUALS_LABEL = 'equals';
export const EQUALS_ANY = 'equals any';
export const NOT_EQUALS_ANY = 'does not equal any';
export const CONTAINS_LABEL = 'contains';
export const NOT_CONTAINS_LABEL = 'does not contain';
export const NOT_EQUALS_LABEL = 'does not equal';

// All operator options used in the form logic rules separated by category.
export const EQUALS_OPERATOR_OPTIONS = [
    {
        value: LOGIC_OPERATOR_EQUALS,
        displayValue: EQUALS_LABEL,
    },
    {
        value: LOGIC_OPERATOR_NOT_EQUALS,
        displayValue: NOT_EQUALS_LABEL,
    },
];

export const GREATER_LESS_THAN_OPERATOR_OPTIONS = [
    {
        value: LOGIC_OPERATOR_GREATER_THAN,
        displayValue: GREATER_THAN_LABEL,
    },
    {
        value: LOGIC_OPERATOR_LESS_THAN,
        displayValue: LESS_THAN_LABEL,
    },
];

export const CONTAINS_OPERATOR_OPTIONS = [
    {
        value: LOGIC_OPERATOR_CONTAINS,
        displayValue: CONTAINS_LABEL,
    },
    {
        value: LOGIC_OPERATOR_NOT_CONTAINS,
        displayValue: NOT_CONTAINS_LABEL,
    },
];

export const EQUALS_ANY_OPERATOR_OPTIONS = [
    {
        value: LOGIC_OPERATOR_EQUALS_ANY,
        displayValue: EQUALS_ANY,
    },
    {
        value: LOGIC_OPERATOR_NOT_EQUALS_ANY,
        displayValue: NOT_EQUALS_ANY,
    },
];

export const REGEX_OPERATOR_OPTIONS = [
    {
        value: LOGIC_OPERATOR_REGEX,
        displayValue: REGEX_LABEL,
    },
];

export const ALL_OPERATOR_OPTIONS = [
    ...EQUALS_OPERATOR_OPTIONS,
    ...GREATER_LESS_THAN_OPERATOR_OPTIONS,
    ...EQUALS_ANY_OPERATOR_OPTIONS,
    ...CONTAINS_OPERATOR_OPTIONS,
    ...REGEX_OPERATOR_OPTIONS,
];

export const CHECKED = 'Checked';
export const UNCHECKED = 'Unchecked';

export const SINGLE_CHECKBOX_OPERAND_OPTIONS = {
    [CHECKED]: {
        value: 1,
        displayValue: CHECKED,
        label: CHECKED,
    },
    [UNCHECKED]: {
        value: 0,
        displayValue: UNCHECKED,
        label: UNCHECKED,
    },
};
